// this linting rule was flagging errors even after they had been addressed in various manners
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import './makeModel.css';
import { FaQuestionCircle as QuestionCircle } from 'react-icons/lib/fa';
import ReactTooltip from 'react-tooltip';
import ModelDiagram from '../modelFlowDiagram/modelFlowDiagram';
import MultiSelectDrop from '../multiSelectDropdown/multiSelectDropdown';
import TensorFilter from '../tensorFilter/filters/TensorFilter';
import {
  trainModel, retrainModel as retrain, promoteModel, getOemInfo, allAgorithms,
} from '../../services/testResultsService';

class MakeModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedChecked: false,
      algorithmDescription: 'Select your algorithm',
      algorithms: [],
      analysisType: 'Select Analysis',
      batchParams: {
        customerNote: '',
        deviceModelType: '',
        hyperParameters: [],
        lastUpdate: moment(),
        modelAction: 'create',
        modelLabels: [],
        modelTypeName: 'Select Algorithm',
        numOfRun: 1,
        oemId: '',
        properties: [],
        propertiesOnFailure: [],
        rangeEnd: moment(),
        rangeStart: moment().subtract(3, 'days'),
        runTime: '',
        softwareVersion: 'version 1.0',
        status: 'In-Progress',
        trainModelName: '',
        trainPct: 67,
        validation: '',
        versionId: 1,
      },
      deviceNumber: '',
      kClusters: 2,
      num_round: 10,
      num_samples_per_tree: 256,
      num_trees: 100,
      oemInfo: {
      },
      oemTypes: [],
      periodicity: 'Hourly',
      promoteOrRetrain: 'retrain',
      retrainModel: false,
      shingle: 2,
      softwareVersions: {
      },
    };

    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.checkModelParameters = this.checkModelParameters.bind(this);
    this.handlePercentageChange = this.handlePercentageChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.retrieveOemInfo = this.retrieveOemInfo.bind(this);
    this.retrieveAlgorithms = this.retrieveAlgorithms.bind(this);
  }

  componentDidMount() {
    const { retrainModel } = this.props;
    // console.log(getModelListByOEM().then(response => console.log(response)));
    if (retrainModel) {
      this.setState({
        retrainModel: true,
      });
      this.setRetrainBatchParams();
    }
    this.retrieveOemInfo();
    this.retrieveAlgorithms();
  }

  setRetrainBatchParams() {
    const { modelInfo, session } = this.props;
    const { batchParams } = this.state;
    const batch = {
      ...batchParams,
    };
    const numberOfRuns = modelInfo.NumOfRun + 1;
    batch.customerNote = modelInfo.CustomerNote;
    batch.deviceModelType = modelInfo.DeviceModelType;
    batch.numOfRun = numberOfRuns;
    batch.modelAction = 'retrain';
    batch.oemId = session.info.origin_oem_str || modelInfo.OemID;
    batch.modelType = modelInfo.ModelType;
    batch.properties = modelInfo.Properties;
    batch.softwareVersion = modelInfo.SoftwareVersion;
    batch.versionId = modelInfo.VersionID;
    batch.trainModelName = modelInfo.trainModelName;
    batch.runTime = modelInfo.RunTime;
    batch.hyperParameters = modelInfo.Hyperparameters;
    batch.validation = modelInfo.Validation;
    this.setState({
      batchParams: batch,
    });
  }

  checkboxClicked = (event) => {
    const { batchParams } = this.state;
    const propertyState = [...batchParams.properties];
    const batch = {
      ...batchParams,
    };
    const propertyValue = event.target.getAttribute('value');
    if (! event.target.classList.contains('checked')) {
      event.target.classList.add('checked');
      propertyState.push(propertyValue);
      batch.properties = propertyState;
    } else {
      // if its unchecked, the value is removed from the state array
      event.target.classList.remove('checked');
      propertyState.forEach((item, index) => {
        if (item === propertyValue) {
          propertyState.splice(index, 1);
          batch.properties = propertyState;
        }
      });
    }
    this.setState({
      batchParams: batch,
    });
  }

  failureCheckboxClicked = (event) => {
    const { batchParams } = this.state;
    const propertiesOnFailureState = [...batchParams.propertiesOnFailure];
    const batch = {
      ...batchParams,
    };
    const propertyValue = event.target.getAttribute('value');
    if (! event.target.classList.contains('checked')) {
      event.target.classList.add('checked');
      propertiesOnFailureState.push(propertyValue);
      batch.propertiesOnFailure = propertiesOnFailureState;
    } else {
      // if its unchecked, the value is removed from the state array
      event.target.classList.remove('checked');
      propertiesOnFailureState.forEach((item, index) => {
        if (item === propertyValue) {
          propertiesOnFailureState.splice(index, 1);
          batch.propertiesOnFailure = propertiesOnFailureState;
        }
      });
    }
    batch.modelLabels = propertiesOnFailureState;
    this.setState({
      batchParams: batch,
    });
  }

  handleDropdownChange = (e) => {
    const {
      oemInfo,
      batchParams,
      softwareVersions
    } = this.state;
    const element = e.target;
    const newVal = element.value;
    const id = element.name;
    const batch = {
      ...batchParams,
    };
    if (id === 'deviceModelType') {
      const newOem = oemInfo;
      const [newVersion] = softwareVersions[newVal];
      batch.softwareVersion = newVersion;
      const newNumber = newOem[newVal][batch.softwareVersion];
      this.setState({
        deviceNumber: newNumber,
      });
    }
    if (id === 'periodicity') {
      batch.hyperParameters = `[{"periodicity":"${newVal}"}]`;
      this.setState({
        batchParams: batch,
        periodicity: newVal,
      });
      return;
    }
    batch[id] = newVal;
    this.setState({
      batchParams: batch,
    });
  }

  handleInputChange = (e) => {
    const { batchParams } = this.state;
    const { name, value } = e.target;
    let val = value;
    const newName = name;
    const batch = {
      ...batchParams,
    };
    if (newName === 'trainModelName') val = val.replace(/[^a-zA-Z0-9]/g, '');
    batch[newName] = val;
    this.setState({
      batchParams: batch,
    });
  }

  handleAdvancedChecked = () => {
    const { advancedChecked } = this.state;
    this.setState({
      advancedChecked: ! advancedChecked,
    });
  }

  handleAlgorithmChange = (e) => {
    const { algorithms, batchParams } = this.state;
    const batch = {
      ...batchParams,
    };
    const element = e.target;
    const newVal = element.value;
    const id = element.name;
    if (id === 'modelTypeName') {
      const als = [...algorithms];
      als.forEach(((algorithm) => {
        if (algorithm.modelTypeName === newVal) {
          this.setState({
            algorithmDescription: algorithm.information,
          });
        }
      }));
    }
    if (id === 'analysisType' || id === 'modelTypeName') {
      if (newVal === 'Random Cut Forest') {
        batch.modelTypeName = 'Random Cut Forest';
        batch.hyperParameters = '[{"num_samples_per_tree":"256", "num_trees": "100", "shingle": "2"}]';
      } else if (newVal === 'Moving Average') {
        batch.modelTypeName = 'Moving Average';
        batch.hyperParameters = '[{"periodicity":"hourly"}]';
      } else if (newVal === 'Cumulative Distribution Function') {
        batch.modelTypeName = 'Cumulative Distribution Function';
        batch.hyperParameters = [];
      } else if (newVal === 'KMeans Clustering') {
        batch.modelTypeName = 'KMeans Clustering';
        batch.hyperParameters = '[{"k":"2"}]';
      } else if (newVal === 'DeepAR') {
        batch.modelTypeName = 'DeepAR';
        batch.hyperParameters = [];
      } else if (newVal === 'XGBoost') {
        batch.modelTypeName = newVal;
        batch.hyperParameters = '[{"num_round": "10"}]';
      }
      this.setState({
        analysisType: newVal,
        batchParams: batch,
      });
      return;
    }
    batch[id] = newVal;
    this.setState({
      batchParams: batch,
    });
  }

  handleRadioChange(e) {
    this.setState({
      promoteOrRetrain: e.target.value,
    });
  }

  handleChangeEnd(date) {
    const { batchParams } = this.state;
    const batch = {
      ...batchParams,
    };
    batch.rangeEnd = date;
    this.setState({
      batchParams: batch,
    });
  }

  retrieveOemInfo() {
    getOemInfo().then((requestData) => {
      if (requestData.body) {
        if (requestData.body.data.length > 0) {
          const { batchParams } = this.state;
          const oemContainer = requestData.body.data[0];
          const oemObject = oemContainer.OemData;
          const oemTypes = Object.keys(oemObject);
          const softwareVersions = {
          };
          oemTypes.forEach(model => {
            softwareVersions[model] = [];
            const filteredSoftware = Object.entries(oemObject[model]);
            const usableVersionList = filteredSoftware.filter(versionCount => versionCount[1] > 0);
            usableVersionList.forEach(usableVersion => {
              if (! softwareVersions[model].includes(usableVersion[0])) softwareVersions[model].push(usableVersion[0]);
            });
          });

          const batch = {
            ...batchParams,
          };
          const deviceModelType = oemTypes[0];
          batch.deviceModelType = deviceModelType;

          const deviceNumber = oemObject[Object.keys(oemObject)[0]][0];

          const propertiesList = oemContainer.Properties2;
          this.setState({
            batchParams: batch,
            deviceNumber,
            oemInfo: oemObject,
            oemTypes,
            propertiesList,
            softwareVersions,
          });
        }
      }
    });
  }

  retrieveAlgorithms() {
    allAgorithms().then((requestData) => {
      if (requestData.body.Items) {
        const algorithmInfo = requestData.body.Items.map((item) => {
          const obj = {
          };
          obj.modelTypeName = item.modelTypeName;
          obj.information = item.Information;
          return obj;
        });
        this.setState({
          algorithms: algorithmInfo,
        });
      }
    });
  }

  checkModelParameters() {
    const {
      closeModal, retrainModel, reloadModels, session
    } = this.props;
    const { batchParams, promoteOrRetrain } = this.state;
    const batch = {
      ...batchParams,
    };
    const start = batch.rangeStart;
    const end = batch.rangeEnd;
    const update = batch.lastUpdate;
    const s = moment.utc(start).startOf('day');
    const e = moment.utc(end).startOf('day');
    const upd = moment.utc(update).startOf('day');
    const startDate = s.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
    const endDate = e.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
    const updateDate = upd.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
    batch.rangeStart = startDate;
    batch.rangeEnd = endDate;
    batch.lastUpdate = updateDate;
    batch.oemId = session.info.origin_oem_str;
    if (batch.customerNote === '') batch.customerNote = 'No description';
    if (retrainModel) {
      if (promoteOrRetrain === 'promote') {
        promoteModel(batch.trainModelName, batch.versionId).then(() => reloadModels());
      } else if (promoteOrRetrain === 'retrain') {
        retrain(batch).then(() => reloadModels());
      }
    } else {
      trainModel(batch).then(() => reloadModels());
    }
    setTimeout(closeModal, 1000);
  }

  handleChangeStart(date) {
    const { batchParams } = this.state;
    const batch = {
      ...batchParams,
    };
    batch.rangeStart = date;
    this.setState({
      batchParams: batch,
    });
  }

  handlePercentageChange(e) {
    const { batchParams } = this.state;
    const val = e.target.value;
    const batch = {
      ...batchParams,
    };
    batch.trainPct = val;
    this.setState({
      batchParams: batch,
    });
  }

  handleHyperparameterChange(algorithm, e, variable) {
    const {
      batchParams, num_samples_per_tree, num_trees, shingle
    } = this.state;
    const val = e.target.value;
    const batch = {
      ...batchParams,
    };
    if (algorithm === 'kClusters') {
      const clusterVal = `[{"k":"${val}"}]`;
      batch.hyperParameters = clusterVal;
      this.setState({
        batchParams: batch,
        kClusters: val,
      });
    } else if (algorithm === 'XGBoost') {
      const num_round = `[{"num_round": "${val}"}]`;
      batch.hyperParameters = num_round;
      this.setState({
        batchParams: batch,
        num_round: val,
      });
    } else if (algorithm === 'RCF') {
      let rcfSampVal = num_samples_per_tree;
      let rcfTrees = num_trees;
      let rcfFeat = shingle;
      if (variable === 'num_samples_per_tree') { rcfSampVal = val; }
      if (variable === 'num_trees') { rcfTrees = val; }
      if (variable === 'shingle') { rcfFeat = val; }
      const rcfVals = `[{"num_samples_per_tree":"${rcfSampVal}",
      "num_trees" : "${rcfTrees}", "shingle": "${rcfFeat}"}]`;

      batch.hyperParameters = rcfVals;
      this.setState({
        batchParams: batch,
        num_samples_per_tree: rcfSampVal,
        num_trees: rcfTrees,
        shingle: rcfFeat,
      });
    }
  }

  render() {
    const {
      algorithms,
      algorithmDescription,
      advancedChecked,
      batchParams,
      deviceNumber,
      kClusters,
      oemTypes,
      promoteOrRetrain,
      retrainModel,
      shingle,
      num_round,
      num_samples_per_tree,
      num_trees,
      periodicity,
      analysisType,
      propertiesList,
      softwareVersions,
    } = this.state;
    const { modelInfo } = this.props;
    let modelProperties;

    if (modelInfo.Properties) {
      modelProperties = modelInfo.Properties.map((property) => (
        <li className="model-properties" key={property}>{property}</li>
      ));
    }

    const algorithmList = algorithms.map(algorithm => (
      <option value={algorithm.modelTypeName}
        key={algorithm.modelTypeName}
      >
        {algorithm.modelTypeName}
      </option>
    ));
    let testedDevices;
    testedDevices = (100 - modelInfo.TrainPct) / 100 * deviceNumber;
    testedDevices = parseInt(testedDevices, 10);
    return (
      <div className="make-model-modal">
        <TensorFilter handleChangeStart={this.handleChangeStart}
          handleChangeEnd={this.handleChangeEnd}
          selectedStart={batchParams.rangeStart}
          selectedEnd={batchParams.rangeEnd}
          modelsPage
          oemModels={oemTypes}
          handleDropdownChange={this.handleDropdownChange}
          oemModel={batchParams.deviceModelType}
          softwareVersion={batchParams.softwareVersion}
          softwareVersions={softwareVersions[batchParams.deviceModelType] || []}
          retrainModel={retrainModel}
          promoteOrRetrain={promoteOrRetrain}
        />
        <div className={retrainModel ? 'hide' : 'create-model flex'}>
          <div className="left-column">
            <div className="model-name">
              <p className="param-header">Name Your Model:</p>
              <input maxLength={30}
                placeholder="Enter Model Name"
                name="trainModelName"
                value={batchParams.trainModelName}
                onChange={this.handleInputChange}
                className={batchParams.trainModelName.length === 0 ? 'error' : ''}
              />
            </div>
            <div className={advancedChecked ? 'percentage-to-train show' : 'hide'}>
              <p className="param-header">Select the % of devices to train</p>
              <p>(Choose between 60% and 80%)</p>
              <input type="number"
                min="60"
                max="80"
                value={batchParams.trainPct}
                onChange={this.handlePercentageChange}
              />
            </div>
            <div className={advancedChecked ? 'hide' : 'select-analysis show'}>
              <p className="param-header">Select Analysis</p>
              <select onChange={this.handleAlgorithmChange}
                name="analysisType"
                value={analysisType}
              >
                <option disabled>Select Analysis</option>
                <option value="Moving Average">Anomaly Detection | Moving Average</option>
                <option value="XGBoost">Failure Prediction | XGBoost</option>
                <option value="DeepAR">Forecast Events | Deep AR</option>
              </select>
            </div>

          </div>
          <hr className="separation-line"
            width="1"
            height="300"
          />

          <div className="middle-column">
            <div className="properties">
              <p className="param-header">Select OEM Model Properties</p>
              <MultiSelectDrop list={propertiesList}
                checkboxClicked={this.checkboxClicked}
                failureCheckboxClicked={this.failureCheckboxClicked}
                showOnFailure={
                  batchParams.modelTypeName === 'XGBoost'}
              />
            </div>
            <div className="model-description">
              <p className="param-header">Add Notes: </p>
              <textarea onChange={this.handleInputChange}
                name="customerNote"
                cols="31"
                rows="2"
                placeholder="Give your model a description..."
              />
            </div>
            <div className={advancedChecked ? 'algorithm show' : 'hide'}>
              <div className="algorithm-title-tip">
                <p className="param-header">Select Algorithm</p>
                <QuestionCircle size="21"
                  className="question-circle"
                  data-for="algorithm"
                  data-tip
                  onClick={(e) => { e.stopPropagation(); }}
                />
                <ReactTooltip id="algorithm"
                  effect="solid"
                  type="light"
                  place="right"
                  className="tooltip"
                >
                  <span>
                    {algorithmDescription}
                  </span>
                </ReactTooltip>
              </div>
              <select onChange={this.handleAlgorithmChange}
                name="modelTypeName"
                id=""
                value={batchParams.modelTypeName}
              >
                <option disabled>Select Algorithm</option>
                {algorithmList}
              </select>
            </div>
          </div>
          <hr className="separation-line"
            width="1"
            size="300"
          />
          <div>
            <div className={advancedChecked ? 'right-column show' : 'hide'}>
              <div className={batchParams.modelTypeName === 'KMeans Clustering' ? 'algorithms show' : 'hide'}>
                <p>K-Means Clustering</p>
                <div className="inputs">
                  <div className="input-field">
                    <label htmlFor="kClusterInput">
                      {'K clusters'}
                    </label>
                    <input type="number"
                      value={kClusters}
                      min={2}
                      onChange={e => (this.handleHyperparameterChange('kClusters', e))}
                    />
                  </div>
                </div>
              </div>
              <div className={batchParams.modelTypeName === 'XGBoost' ? 'algorithms show' : 'hide'}>
                <p>XGBoost</p>
                <div className="inputs">
                  <div className="input-field">
                    <label htmlFor="XGBoostInput">
                      {'num_round'}
                    </label>
                    <input type="number"
                      value={num_round}
                      min={10}
                      onChange={e => (this.handleHyperparameterChange('XGBoost', e))}
                    />
                  </div>
                </div>
              </div>
              {batchParams.modelTypeName === 'Random Cut Forest' && (
                <div className={batchParams.modelTypeName === 'Random Cut Forest' ? 'algorithms show' : 'hide'}>
                  <p>Random Cut Forest (RCF)</p>
                  <div className="inputs">
                    <div className="input-field">
                      <label htmlFor="rcfTreeSamples">
                        {'num_samples_per_tree'}
                      </label>
                      <input type="number"
                        value={num_samples_per_tree}
                        min={1}
                        onChange={e => (this.handleHyperparameterChange('RCF', e, 'num_samples_per_tree'))}
                      />
                    </div>
                    <div className="input-field">
                      <label htmlFor="rcfTreeNum">
                        {'num_trees'}
                      </label>
                      <input type="number"
                        value={num_trees}
                        min={50}
                        onChange={e => (this.handleHyperparameterChange('RCF', e, 'num_trees'))}
                      />
                    </div>
                    <div className="input-field">
                      <label htmlFor="shingle">
                        {'shingle'}
                      </label>
                      <input type="number"
                        value={shingle}
                        onChange={e => (this.handleHyperparameterChange('RCF', e, 'shingle'))}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className={batchParams.modelTypeName === 'Moving Average' ? 'algorithms show' : 'hide'}>
                <p>Select Periodicity</p>
                <select onChange={this.handleDropdownChange}
                  name="periodicity"
                  value={periodicity}
                >
                  <option disabled>Select Periodicity</option>
                  <option value="hourly">Hourly</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className={retrainModel ? 'flex' : 'hide'}>
          <div className="left-update-column">
            <p>
              {'Name: '}
              {modelInfo.trainModelName}
            </p>
            <p>
              {'Version: '}
              {modelInfo.VersionID}
            </p>
            <p>
              {'OEM Model: '}
              {modelInfo.DeviceModelType}
            </p>
            <p>
              {'Algorithm: '}
              {modelInfo.ModelType}
            </p>
            <p>
              {'Number of Runs: '}
              {modelInfo.NumOfRun}
            </p>
            <p>
              {'Train Percentage: '}
              {modelInfo.TrainPct}
            </p>
            <p>
              {'Devices Tested: '}
              {testedDevices}
            </p>
            <ul className="model-properties">
              {'Properties: '}
              {modelProperties}
            </ul>
          </div>
          <div className="middle-update-column">
            <div className="promote-version">
              <div className="retrain-promote-header">
                {' '}
                <p className="param-header">Retrain or Promote</p>
                <QuestionCircle size="21"
                  className="question-circle"
                  data-for="promoteOrRetrain"
                  data-tip
                  onClick={(e) => { e.stopPropagation(); }}
                />
                <ReactTooltip id="promoteOrRetrain"
                  effect="solid"
                  type="light"
                  place="right"
                  className="tooltip"
                >

                  <span>
                    <div>
                      <strong>Retrain or Promote:</strong>
                      {' '}
                    </div>
                    <br />
                    <div>
                      {`Retraining a model is recommended when looking to improve a model's accuracy.
                      When we retrain a model, we are dispatching it to the training and testing protocols once more.`}
                    </div>
                    <br />
                    <div>
                      {`The only reason to promote a model would be if you find that
                      an earlier version is more accurate or effective than a newer one.
                      In this case, you can promote a model to be the most up to date version.`}
                    </div>
                    <br />
                    <div>
                      <em>
                        {`Example: If we find that Version 3 was 80% accurate, and version 4 was only 72% accurate,
                        we chould choose to promote Version 3,
                        so that it now becomes Version 5, the lastest version of this model.`}
                      </em>
                      <br />
                    </div>
                  </span>
                </ReactTooltip>
              </div>
              <div className="promote-inputs">
                <div className="radio-btns">
                  <label htmlFor="retrainRadio">
                    <input type="radio"
                      value="retrain"
                      checked={promoteOrRetrain === 'retrain'}
                      onChange={this.handleRadioChange}
                    />
                    {'Retrain'}
                  </label>
                  <label htmlFor="promoteRadio">
                    <input type="radio"
                      value="promote"
                      checked={promoteOrRetrain === 'promote'}
                      onChange={this.handleRadioChange}
                    />
                    {'Promote'}
                  </label>
                </div>

              </div>

            </div>
            <div className="existing-notes">
              <p>
                {'Notes: '}
                {modelInfo.CustomerNote}
              </p>
            </div>
          </div>
          <div className="right-update-column">
            <div className={promoteOrRetrain === 'promote' ? 'hide' : 'show percentage-to-train'}>
              <p className="param-header">Select the % of devices to train</p>
              <p>(Choose between 60% and 80%)</p>
              <input type="number"
                min="60"
                max="80"
                value={batchParams.trainPct}
                onChange={this.handlePercentageChange}
              />
            </div>
            <div className={promoteOrRetrain === 'promote' ? 'hide' : 'show model-description'}>
              <p className="param-header">Add Notes: </p>
              <textarea onChange={this.handleInputChange}
                name="customerNote"
                cols="38"
                rows="4"
                placeholder="Update your notes for this model..."
              />
            </div>

          </div>
        </div>
        <div className={retrainModel ? 'hide' : 'show'}>
          <ModelDiagram trainPct={batchParams.trainPct}
            numberOfDevices={deviceNumber}
            oemModel={retrainModel ? modelInfo.DeviceModelType : batchParams.deviceModelType}
          />
        </div>
        <div className={retrainModel ? 'hide' : 'show btn-and-advanced'}>
          <button className="create-model-btn"
            onClick={this.checkModelParameters}
            type="button"
            disabled={batchParams.trainModelName.length === 0}
          >
            {'Create Model and Start Training and Testing'}
          </button>
          <label htmlFor="acheck">
            {'Show advanced settings'}
            <input type="checkbox"
              id="acheck"
              className="advancedChecked"
              checked={advancedChecked}
              onChange={this.handleAdvancedChecked}
            />
          </label>
        </div>
        <button className={retrainModel && promoteOrRetrain === 'retrain' ? 'show create-model-btn' : 'hide'}
          onClick={this.checkModelParameters}
          type="button"
        >
          {'Retrain Model and Start Training and Testing'}
        </button>
        <button className={promoteOrRetrain === 'promote' ? ' show create-model-btn' : 'hide'}
          onClick={this.checkModelParameters}
          type="button"
        >
          {'Promote Model'}
        </button>
      </div>
    );
  }
}

export default MakeModel;
